import { Pipe, PipeTransform } from '@angular/core';
import { SortOrder } from './types/sort-order';

@Pipe({
  name: 'phdsoftOrderBy'
})
export class PhdSoftOrderByPipe implements PipeTransform {
  /**
   * Parse expression, split into items
   *
   * @returns string[]
   */
  private static parseExpression(expression: string): string[] {
    expression = expression.replace(/\[(\w+)\]/g, '.$1');
    expression = expression.replace(/^\./, '');
    return expression.split('.');
  }

  /**
   * Get value by expression
   *
   * @returns any
   */
  private static getValue(object: any, expression: string[]): string {
    for (let i = 0, n: number = expression.length; i < n; ++i) {
      const k: string = expression[i];
      if (!(k in object)) {
        return '';
      }
      object = object[k];
    }

    return object;
  }

  /**
   * Set value by expression
   *
   */
  private static setValue(object: any, value: any, expression: string[]): void {
    let i: number;
    for (i = 0; i < expression.length - 1; i++) {
      object = object[expression[i]];
    }
    object[expression[i]] = value;
  }

  /**
   * isDeepLink. Verifica se a expressão possui deepLink
   * @returns boolean
   */
  private isDeepLink(expression: any): boolean {
    return expression && expression.indexOf('.') !== -1;
  }

  stringToLower(a: any): string | any {
    if (a instanceof String) {
      if (a) {
        a = a.toLowerCase();
      }
    }
    return a;
  }

  /**
   * Sort array
   * @returns any
   */
  private sort(value: any[], expression?: any): any[] {
    return value.sort(
      (a: any, b: any): number => {
        a = this.stringToLower(a);
        b = this.stringToLower(b);

        if (!expression) {
          return a > b ? 1 : a < b ? -1 : 0;
        } else {
          if (!this.isDeepLink(expression)) {
            const A: string = this.stringToLower(a[expression]);
            const B: string = this.stringToLower(b[expression]);
            return A > B ? 1 : A < B ? -1 : 0;
          }
        }

        const Aa: string = this.stringToLower(
          PhdSoftOrderByPipe.getValue(a, expression)
        );
        const Bb: string = this.stringToLower(
          PhdSoftOrderByPipe.getValue(b, expression)
        );

        return Aa > Bb ? 1 : Aa < Bb ? -1 : 0;
      }
    );
  }

  /**
   * Sort array
   * @returns any[]
   */
  private sortArray(value: any[], expression?: any, reverse?: boolean): any[] {
    if (!this.isDeepLink(expression)) {
      expression = PhdSoftOrderByPipe.parseExpression(expression);
    }

    const array: any[] = this.sort(value, expression);
    if (reverse) {
      return array.reverse();
    }

    return array;
  }

  /**
   * Transform Object
   *
   * @returns any[]
   */
  private transformObject(
    value: any | any[],
    expression?: any,
    reverse?: boolean
  ): any {
    const parsedExpression = PhdSoftOrderByPipe.parseExpression(expression);
    let lastPredicate: any = parsedExpression.pop();
    let oldValue: any = PhdSoftOrderByPipe.getValue(value, parsedExpression);

    if (!(oldValue instanceof Array)) {
      parsedExpression.push(lastPredicate);
      lastPredicate = null;
      oldValue = PhdSoftOrderByPipe.getValue(value, parsedExpression);
    } else {
      if (!oldValue) {
        return value;
      }
    }

    const newValue = this.transform(oldValue, lastPredicate, reverse);
    PhdSoftOrderByPipe.setValue(value, newValue, parsedExpression);
    return value;
  }

  public transform(
    value: Array<any>,
    options?: any,
    reverse?: boolean
  ): Array<any> {

    try {
      if (options?.order === SortOrder.ZA) {
        reverse = true;
      }

      const isArray = value instanceof Array;

      if (options?.order !== SortOrder.None) {
        if (isArray) {
          return this.sortArray(value, options.expression, reverse);
        } else {
          if (typeof value === 'object') {
            return this.transformObject(value, options.expression, reverse);
          }
        }
      }

      options.list.onChangeHandle({ list: options.list, action: 'sort' });

      return value;
    } catch (error) {
      console.error('[PhdSoftOrderByPipe] => Error: ', error);
    }
  }
}
